import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextInput } from '../../shared/components/text-input/text-input';
import { Router } from '@angular/router';
import { StateService } from '../../shared/services/state-service';
import { AuthService } from '../../core/services/auth-service';
import { UserRole } from '../../shared/model/role';
import { CommonModule } from '@angular/common';
import { NavigationService } from '../../core/navigation/navigation.service';


@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, TextInput, FormsModule, CommonModule],
  templateUrl: './login.html',

  styleUrl: './login.scss',
})
export class Login implements OnInit {

  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private stateService = inject(StateService);
  private authService = inject(AuthService);
  private navigationService = inject(NavigationService);

  // private loginClick$ = new Subject<void>();
  loginForm!: FormGroup;
  roles = Object.values(UserRole);
  email = '';
  password = '';
  rememberMe = false;
  showPassword = false;
  error: string = "";

  features = [
    'Real-time visual analytics dashboard',
    'Smart lens filters & custom views',
    'Team collaboration & shared workspaces',
    'Export reports in one click',
  ];

  ngOnInit(): void {
    this.intilizationForm();
  }

  intilizationForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    })
  }

  onLogin() {
    if (this.loginForm.invalid) { return };

    // const { email, role } = this.loginForm.value;
    let payload = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
    }



    this.authService.login(payload).subscribe({
      next: (res) => {
        // localStorage.setItem('userRole', res.authResponse.role);
        this.setRoleInStorage(res.authResponse.role);
        localStorage.setItem('data', JSON.stringify(res.authResponse));
        this.authService.auth();

        let role = this.getRole();
        this.stateService.setUserLoggedIn(true);

        this.navigateByRole(role);
        this.navigationService.setRole(this.getRole() as UserRole)
      },
      error: (err) => {
        this.error = "Invalid email or password";
      }
    })

  }

  private navigateByRole(role: string | undefined): void {
    switch (role) {
      case UserRole.SUPERADMIN:
        this.router.navigate(['/superAdmin/dashboard/overview']);
        break;
      case UserRole.ADMIN:
        this.router.navigate(['/admin/dashboard/overview']);
        break;
      case UserRole.USER:
        this.router.navigate(['/user/dashboard/overview']);
        break;
      case UserRole.VIEWER:
        this.router.navigate(['/viewer/dashboard/overview']);
        break;
      case UserRole.TEAMMANAGER:
        this.router.navigate(['/teamManager/dashboard/overview']);
        break;
      default:
        this.router.navigate(['/dashboard']);
    }
  }


  private setRoleInStorage(role: string): void {
    let roleName = '';

    switch (role) {
      case "OrgAdmin":
        roleName = 'admin';
        break;

      case "SuperAdmin":
        roleName = 'superAdmin';
        break;

      case "TeamManager":
        roleName = 'teamManager';
        break;

      case "Viewer":
        roleName = 'viewer';
        break;

      case "User":
        roleName = 'user';
        break;

      default:
        roleName = 'unknown';
    }

    localStorage.setItem('userRole', roleName);
  }

  loginWithGoogle() {
  }

  loginWithGitHub() {
  }

  getRole(): string | undefined {
    return localStorage.getItem('userRole')?.toString()
  }

}
